/**
 * Radar Service
 * Fetches Technology Radar data from backend monitoring endpoints
 */

import { authenticatedFetch } from './authService.js';

function resolveApiBase() {
  let base = window.BATEMO_API?.baseUrl !== undefined ? window.BATEMO_API.baseUrl : '/api/v1';
  if (window.location.protocol === 'https:' && typeof base === 'string' && base.startsWith('http://')) {
    base = base.replace('http://', 'https://');
  }
  return base;
}

const API_BASE = {
  toString: () => resolveApiBase(),
  valueOf: () => resolveApiBase()
};

/**
 * Fetch chemistry monitoring data
 */
export async function fetchChemistryData() {
  const response = await authenticatedFetch(`${API_BASE}/monitoring/chemistry`);

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to fetch chemistry data');
  }

  return response.json();
}

/**
 * Fetch performance monitoring data
 */
export async function fetchPerformanceData() {
  const response = await authenticatedFetch(`${API_BASE}/monitoring/performance`);

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to fetch performance data');
  }

  return response.json();
}

/**
 * Fetch Na-ion vs LFP monitoring data
 */
export async function fetchNaionLfpData() {
  const response = await authenticatedFetch(`${API_BASE}/monitoring/naion-vs-lfp`);

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to fetch Na-ion vs LFP data');
  }

  return response.json();
}
